import React, { FC, useRef } from 'react'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg';
import { getImage } from '../../../../app/utlis/imageConstants';
import { motion, useInView } from 'framer-motion'

interface MoodyMonthAppContentProps {
    moodyProjectData: any
}

const MoodyMonthAppContent: FC<MoodyMonthAppContentProps> = ({ moodyProjectData }) => {
    const containerRef = useRef(null);
    const isInView = useInView(containerRef, { once: false, amount: 0.2 });

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { 
            opacity: 0, 
            y: 20 
        },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: {
                type: "spring",
                damping: 15,
                stiffness: 100
            }
        }
    };

    const iconVariants = {
        hidden: { scale: 0.8, opacity: 0 },
        visible: { 
            scale: 1, 
            opacity: 1,
            transition: {
                type: "spring",
                delay: 0.2,
                duration: 0.5
            }
        }
    };

    // New hover animations
    const cardHoverVariants = {
        hover: {
            scale: 1.05,
            boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 20
            }
        }
    };

    const iconHoverVariants = {
        hover: {
            scale: 1.15,
            rotate: 5,
            transition: {
                type: "spring",
                stiffness: 400,
                damping: 10
            }
        }
    };

    return (
        <div className='px-4 sm:px-8 md:px-12' ref={containerRef}>
            <motion.div 
                className='grid grid-cols-1 sm:grid-cols-2 justify-center items-center gap-4 sm:gap-6 p-4 sm:p-8 md:p-20 md:pt-16'
                variants={containerVariants}
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
            >
                {moodyProjectData.moodyProjectDetails.AppDetails.map((detail: any, index: number) => {
                    let img = getImage(detail?.image ?? "") ?? "";
                    return (
                        <motion.div 
                            key={index}
                            variants={itemVariants}
                            whileHover="hover"
                            className="cursor-pointer"
                        >
                            <motion.div 
                                className='p-4 sm:p-6 rounded-3xl flex items-center gap-3 sm:gap-4 w-full backdrop-blur-sm'
                                variants={cardHoverVariants}
                            >
                                <motion.div 
                                    className='w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center bg-moodyColor'
                                    variants={{...iconVariants, ...iconHoverVariants}}
                                >
                                    <div className='flex items-center justify-center text-black font-black text-base sm:text-lg md:text-xl'>
                                        <DynamicSVG color='#000' >{img}</DynamicSVG>
                                    </div>
                                </motion.div>
                                <div className='flex flex-col gap-1'>
                                    <span className={`text-lg sm:text-xl font-medium text-white`}>
                                        <b>{detail.title}</b>   
                                    </span>
                                    <span className='text-sm sm:text-base text-[#E0E0E0]'>
                                        {detail.sub_title}
                                    </span>
                                </div>
                            </motion.div>
                        </motion.div>
                    )
                })}
            </motion.div>
        </div>
    )
}

export default MoodyMonthAppContent;